import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import ProductProp, { PRODUCT_STATIC_TAB } from '../../propTypes/productProp';
import { useSanitize } from '../../../../services/customHooks';

function CustomTabContent(props) {
  const { product, activeTabs, activeTab } = props;
  const {
    isPack,
    packVariations,
    variations,
    customTabs = [],
    description: productDescription = null,
  } = product;
  const description = useSanitize(productDescription);

  const specificationVariations = isPack
    ? packVariations.map(pV => ({ ...pV, ...pV.variation }))
    : variations;

  const renderTabContent = useCallback(
    tab => {
      const content = useSanitize(tab?.content);
      switch (tab._id) {
        case PRODUCT_STATIC_TAB.DESCRIPTION:
          return (
            <>
              {description && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                  style={{ marginBottom: '5rem' }}
                />
              )}
            </>
          );
        case PRODUCT_STATIC_TAB.SPECIFICATIONS:
          return (
            <div className="tab-pane" id="specifications_tab" role="tabpanel">
              {specificationVariations.map((v, i) => (
                <div className="option">
                  <input
                    defaultChecked
                    type="checkbox"
                    id={`toggle${i}`}
                    className="toggle"
                  />
                  <label className="title" htmlFor={`toggle${i}`}>
                    <i className="fas fa-caret-right" />
                    {v.name}
                  </label>
                  <div className="content">
                    <table
                      className="table table-striped m-table"
                      style={{ width: '100%' }}
                    >
                      <tbody>
                        {v.attributes.map((at, index) => (
                          <tr className="content" key={`row-${index + 1}`}>
                            <td style={{ width: '7%' }} />
                            <td style={{ width: '20%' }}>
                              {at.attribute.name}
                            </td>
                            <td>{`${at.value}${at.attribute.unit}`}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          );
        default:
          return (
            <>
              {content ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                  style={{ marginBottom: '5rem' }}
                />
              ) : null}
            </>
          );
      }
    },
    [customTabs, specificationVariations, description],
  );

  return (
    <div className="m-portlet__body">
      {renderTabContent(activeTabs?.find(tab => tab._id === activeTab))}
    </div>
  );
}

CustomTabContent.propTypes = {
  product: PropTypes.shape(ProductProp.propType).isRequired,
  activeTabs: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      content: PropTypes.string,
    }),
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
};

export default translate(CustomTabContent);
